<template>
  <div class="box">
    <van-tabs title-active-color="#00476C" color="#00476C" v-model="active" @change="tabsChange">
      <van-tab title="历史学习记录" />
      <van-tab title="历史收藏记录" />
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: "UserContentTab",
  data() {
    return {
      active: 0
    }
  },
  methods: {
    tabsChange() {
      this.$emit('change', this.active)
    },
  }
}
</script>

<style lang="scss" scoped>
.box {
  background: #ffffff;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 20px;
  height: 120px;
  box-shadow: 0px 5px 10px 0px rgba(218, 222, 228, 0.3);
  position: relative;
}
::v-deep {
  .van-tab__text {
    font-weight: bold;
    font-size: 14px;
  }
}
</style>
